'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var randomColor = require('randomcolor');

var _require = require('lodash'),
    replace = _require.replace;

var dyzioPalette = exports.dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  yellow: '#fff28c',
  white: '#f7fafa',
  turquoise: '#8dcece',
  darkBlue: '#233B4B',
  grey: '#8c8c8c'
};

var getRowColors = exports.getRowColors = function getRowColors(index) {
  var opacity = 0.7;
  var fullOpacity = 1;
  var backgroundColours = ['rgba(252, 64, 133, ' + opacity + ')', 'rgba(32, 196, 158, ' + opacity + ')', 'rgba(253, 176, 43, ' + opacity + ')', 'rgba(154, 210, 255, ' + opacity + ')', 'rgba(255, 242, 140, ' + opacity + ')', 'rgba(247, 250, 250, ' + opacity + ')'];
  var mainColor = backgroundColours[index] || randomColor({ format: 'rgba', luminosity: 'light', alpha: 0.7 });
  var borderColor = replace(mainColor, opacity, fullOpacity);
  return {
    mainColor: mainColor,
    borderColor: borderColor
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/utils/colors.js
 ** module id = 380
 ** module chunks = 0
 **/